import { gql } from '@apollo/client';

import { COMPANY_FIELDS, VACANCY_CARD_FIELDS } from './fields';

export const GET_COMPANY_NAME = gql`
  query CompanyName($id: ID!) {
    company(id: $id) {
      name
    }
  }
`;

export const GET_COMPANY_BY_ID = gql`
  ${VACANCY_CARD_FIELDS}
  ${COMPANY_FIELDS}
  query Company($id: ID!) {
    company(id: $id) {
      ...companyFields
      publishedCount
      regionId
      regionName
      specializationName
      ads {
        ...vacancyCardFields
      }
    }
  }
`;
